import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ShowcaseGrid } from "@/components/ShowcaseGrid";

const EASE = [0.22, 1, 0.36, 1];

const WorkIndexPage = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <div className="relative bg-void min-h-screen">
      <Navbar onNavigate={(k) => (k === "work" ? navigate("/work") : navigate(`/#${k}`))} />

      <main className="mx-auto max-w-[1600px] px-6 md:px-12 pt-40 pb-32">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <span className="font-mono text-[11px] tracking-[0.35em] uppercase text-bone/40">
            Selected work
          </span>
          <h1 className="mt-6 font-display text-5xl md:text-8xl lg:text-9xl font-bold uppercase tighter leading-[0.85] text-bone">
            {t.work.title}
          </h1>
          <p className="mt-8 max-w-xl font-body font-light text-lg text-bone/60 leading-relaxed">
            {t.work.intro} — organised by client. Click a showcase to see every piece made for them.
          </p>
        </motion.div>

        <div className="mt-20">
          <ShowcaseGrid />
        </div>
      </main>

      <Footer onNavigate={(k) => navigate(`/#${k}`)} />
    </div>
  );
};

export default WorkIndexPage;
